<div [ngSwitch]="type">
  <form-history-scf
    *ngSwitchCase="formType.SCF"
    [originalBody]="originalBody ?? update.currentBody"
    [update]="update"
    [status]="status"
  ></form-history-scf>
  <form-history-rsswa
    *ngSwitchCase="formType.RSSWA"
    [originalBody]="originalBody ?? update.currentBody"
    [update]="update"
    [status]="status"
  ></form-history-rsswa>
  <form-history-eb
    *ngSwitchCase="formType.EBF"
    [originalBody]="originalBody ?? update.currentBody"
    [update]="update"
    [status]="status"
  >
  </form-history-eb>
  <ppstb-main-s1
    *ngSwitchCase="formType.PPSTB"
    [form]="originalBody ?? update.currentBody"
    [showAmendment]="status?.isViewingAmendment ?? false"
    [disabled]="true"
    [isLogView]="true"
  ></ppstb-main-s1>
  <form-history-rsf
    *ngSwitchCase="formType.RSF"
    [originalBody]="originalBody ?? update.currentBody"
    [update]="update"
    [status]="status"
  ></form-history-rsf>
</div>
